import { createClient } from "next-sanity";

export const client = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: "2024-01-01",
});

export function getClient({ draftMode }: { draftMode: boolean }) {
  return client.withConfig({
    useCdn: !draftMode,
    token: draftMode ? process.env.SANITY_VIEWER_TOKEN : undefined,
    stega: draftMode ? { studioUrl: process.env.NEXT_PUBLIC_SANITY_STUDIO_URL } : undefined,
  })
}